var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInReviewHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.14,
    height: 30,
    viewBox: "0 0 36.14 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "In_Review",
    "data-name": "In Review",
    transform: "translate(-260.275 -132.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M292.833,132.492h-23.79a3.567,3.567,0,0,0-3.56,3.56v11.681h0a6.923,6.923,0,0,0-1.9,10.073l-3.018,3.018a.977.977,0,1,0,1.382,1.381l3.018-3.018a6.89,6.89,0,0,0,6.42,1.017h21.474a3.566,3.566,0,0,0,3.56-3.56V136.052A3.6,3.6,0,0,0,292.833,132.492Zm-26.476,25.3a5.035,5.035,0,0,1-1.381-1.382,5,5,0,1,1,1.381,1.382Zm6.993,1.355-.018.014Zm-1.125.7-.045.021Zm2.093-1.606a6.91,6.91,0,0,0,1.466-6.58,7.052,7.052,0,0,1,3.832-1.137h2.644a7.721,7.721,0,0,1,7.455,7.717Zm1.054-7.63c.027.056.055.111.081.167C275.428,150.725,275.4,150.669,275.373,150.614Zm.22.5c.028.071.053.144.079.216C275.647,151.258,275.621,151.185,275.593,151.114Zm.783-7.43a4.572,4.572,0,1,1,4.562,4.882A4.739,4.739,0,0,1,276.377,143.684Zm18.077,12.961h-.022a1.61,1.61,0,0,1-1.6,1.6h-1.157A9.88,9.88,0,0,0,285.014,149a6.957,6.957,0,0,0,2.447-5.336,6.53,6.53,0,1,0-13.046,0A6.958,6.958,0,0,0,276.863,149a9.132,9.132,0,0,0-1.905.873,6.9,6.9,0,0,0-7.513-2.965V136.052a1.611,1.611,0,0,1,1.6-1.6h23.811a1.61,1.61,0,0,1,1.6,1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M280.66,187.353a3.288,3.288,0,0,0-3.285,3.285.651.651,0,0,0,1.3,0,1.984,1.984,0,0,1,1.982-1.982.651.651,0,0,0,0-1.3Z",
    transform: "translate(-11.532 -36.999)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInReviewHover);
export default __webpack_public_path__ + "static/media/InReviewHover.213ea403c656f2ddd7d2609f920b2251.svg";
export { ForwardRef as ReactComponent };